// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"532":"styles","4952":"npm-async-undefined"}[chunkId] + "." + {"532":"66c007a7","4952":"b5a5e0b5"}[chunkId] + ".css";
};